import React from "react";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import { prefixer } from "stylis";

// Create cache for left-to-right support (default)
const createLtrCache = () =>
  createCache({
    key: "mui-ltr",
    stylisPlugins: [prefixer],
  });

// LTR wrapper
export default function LTR({ children }) {
  const cacheLtr = React.useMemo(() => createLtrCache(), []);
  return <CacheProvider value={cacheLtr}>{children}</CacheProvider>;
}